import { OidcTokenExchangeError } from "../pkce";

const GENERIC_SIGN_IN_ERROR = "Unable to sign in. Please try again.";
const ACCOUNT_EXISTS_MESSAGE =
  "An account with this email already exists in this organization under a different sign-in method. Sign in the way you did before, or ask your P0 administrator to remove the old account.";

const errorCode = (error: unknown): string | undefined => {
  if (typeof error !== "object" || error === null || !("code" in error)) {
    return undefined;
  }

  return typeof error.code === "string" ? error.code : undefined;
};

export const signInErrorMessage = (error: unknown): string => {
  if (error instanceof OidcTokenExchangeError) return error.message;

  switch (errorCode(error)) {
    case "auth/account-exists-with-different-credential":
      return ACCOUNT_EXISTS_MESSAGE;
    default:
      return GENERIC_SIGN_IN_ERROR;
  }
};
